<template>
	<div class="animated fadeIn">
		<OverviewCard
			name="Datasets"
			link="/dataset/0"
			:keywords="keywords"
			:search="search"
			@keywordsChange="setKeywords"
		>
			<table class="table table-bordered table-striped table-sm" v-cloak>
				<thead>
					<tr>
						<th v-for="(col, colKey) in columns" :key="`col-${colKey}`">{{ $t(col) }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(record, recordKey) in records" :key="`record-${recordKey}`">
						<td v-for="(element, elementKey) in record" :key="`element-${elementKey}`">
							<span v-if="element.action == 'delete'" @click="deleteItem(element, true)">
								<i class="fa fa-remove fa-lg"></i>
							</span>
							<span v-if="element.action == 'edit'">
								<router-link v-if="element.link" v-bind:to="element.href">
									<i class="fa fa-edit fa-lg"></i>
								</router-link>
							</span>
							<span v-if="element.action == 'status'">
								<c-switch
									@change="setStatus(element)"
									type="icon"
									size="sm"
									variant="success"
									v-bind="{on: '\uf00c', off: '\uf00d'}"
									:pill="true"
									:checked="element.text"
								/>
							</span>
							<span v-if="element.action == 'txt'">{{ element.text }}</span>
						</td>
					</tr>
					<tr v-if="!records.length" v-cloak>
						<td colspan="4">
							<div class="text-center">{{ $t('no data') }}!</div>
						</td>
					</tr>
				</tbody>
			</table>
			<nav>
				<ul class="pagination">
					<li
						v-for="(pg, key) in pagination_bar"
						class="page-item"
						v-bind:class="{active: pg.activate}"
						:key="`page-${key}`"
					>
						<span class="page-link" @click="fetchDatasets(pg.btn)">{{ pg.btn }}</span>
					</li>
				</ul>
			</nav>
		</OverviewCard>

		<b-modal
			title="Modal title"
			class="modal-primary"
			v-model="deleteModal"
			@ok="deleteItem(0, false)"
		>{{ $t('Do you really need to delete') }} {{ active_element_name }} ?</b-modal>
	</div>
</template>

<script>
	import {cSwitch, OverviewCard} from '../../components'
	import searchMixins from '../../mixins/search'
	import axios from 'axios'

	export default {
		name: 'datasetList',
		components: {
			cSwitch,
			OverviewCard,
		},
		mixins: [searchMixins],
		data() {
			return {
				records: [],
				columns: ['Name', 'Status', 'Edit', 'Delete'],
				page: 1,
				pagination_bar: [],
				deleteModal: false,
				active_element_id: 0,
				active_element_name: '',
				clone_public_ds_id: 0,
				clone_private_ds_id: 0,
			}
		},
		methods: {
			fetchDatasets(page) {
				this.records = []
				this.pagination_bar = []
				this.$root.loader = true
				this.page = page
				axios
					.post('/dataset/get/public/' + page, {
						type: 'dataset',
						keywords: this.keywords,
					})
					.then((response) => {
						this.$root.loader = false
						if (response.data.status == 1) {
							this.page = parseInt(response.data.page)
							for (var i = 0; i < parseInt(response.data.pages_count); i++) {
								var acti_ = false
								if (this.page === i + 1) {
									acti_ = true
								} else {
									acti_ = false
								}
								this.pagination_bar.push({
									btn: (i + 1).toString(),
									activate: acti_,
								})
							}
							for (var i = 0; i < response.data.data.length; i++) {
								var record = response.data.data[i]
								var status = false
								if (parseInt(record['ds_status']) == 1) {
									status = true
								}
								this.records.push([
									{text: record['ds_name'], link: false, action: 'txt', id: record['ds_id']},
									{text: status, link: false, action: 'status', id: record['ds_id']},
									{text: '', link: true, href: '/dataset/' + record['ds_id'], action: 'edit'},
									{text: record['ds_name'], link: false, action: 'delete', id: record['ds_id']},
								])
							}
						}
					})
					.catch(() => {
						this.$root.loader = false
					})
			},
			search() {
				this.fetchDatasets(1)
			},
			setStatus(element) {
				var status = 1
				if (element.text == false) {
					status = 1
				} else {
					status = 0
				}
				axios.post('/dataset/set_status/' + element.id, {status: status}).then((response) => {
					if (response.data.status == 1) {
					}
				})
			},
			deleteItem(element, alarm) {
				if (alarm) {
					this.deleteModal = true
					this.active_element_id = element.id
					this.active_element_name = element.text
				} else {
					if (this.active_element_id > 0) {
						this.$root.loader = true
						axios.post('/dataset/delete/' + this.active_element_id, {}).then((response) => {
							if (response.data.status == 1) {
								this.deleteModal = false
								this.fetchDatasets(this.page)
							}
						})
					}
				}
			},
		},
		mounted() {
			if (parseInt(this.$route.params.page) >= 1) {
				this.page = parseInt(this.$route.params.page)
			}
			this.fetchDatasets(this.page)
		},
	}
</script>
